import type { BatchJobKind } from "../../../lib/corpusApi";
import type { BatchJobKindView } from "./batch_job_kind_contract";
import { ADMISSION_RECHECK_VIEW } from "./kinds/admission_recheck";
import { COVERAGE_GAP_RECHECK_VIEW } from "./kinds/coverage_gap_recheck";
import { DOCUMENT_SECTIONS_REFRESH_VIEW } from "./kinds/document_sections_refresh";
import { FIELD_REANNOTATION_VIEW } from "./kinds/field_reannotation";
import { PUBMED_INGEST_VIEW } from "./kinds/pubmed_ingest";
import { DOCUMENT_INDEXING_REFRESH_VIEW } from "./kinds/document_indexing_refresh";

/** Every registered batch job kind, in the order "New job" offers them — add an entry here
 *  whenever a new kind's folder is added under `kinds/`. */
export const BATCH_JOB_KIND_VIEWS: Record<BatchJobKind, BatchJobKindView> = {
  admission_recheck: ADMISSION_RECHECK_VIEW,
  pubmed_ingest: PUBMED_INGEST_VIEW,
  field_reannotation: FIELD_REANNOTATION_VIEW,
  document_indexing_refresh: DOCUMENT_INDEXING_REFRESH_VIEW,
  document_sections_refresh: DOCUMENT_SECTIONS_REFRESH_VIEW,
  coverage_gap_recheck: COVERAGE_GAP_RECHECK_VIEW,
};

export interface BatchJobKindOption {
  value: BatchJobKind;
  label: string;
}

/** Kinds selectable from "New job". */
export const BATCH_JOB_KIND_OPTIONS: BatchJobKindOption[] = (
  Object.keys(BATCH_JOB_KIND_VIEWS) as BatchJobKind[]
)
  .filter((value) => BATCH_JOB_KIND_VIEWS[value].startedFrom === undefined)
  .map((value) => ({ value, label: BATCH_JOB_KIND_VIEWS[value].label }));
